import { useState } from "react";
import { LearningContent, LearningContentType, LearningContentSubType } from "../service/learningService";

export function useContentsManager(initialContents: LearningContent[] = []) {
    const [contents, setContents] = useState<LearningContent[]>(initialContents);

    const addContent = (type: LearningContentType, subType: LearningContentSubType) => {
        setContents(prev => [
            ...prev,
            { type, subType, value: "", order: prev.length + 1, published: true }
        ]);
    };

    const removeContent = (index: number) => {
        setContents(prev =>
            prev.filter((_, i) => i !== index).map((c, i) => ({ ...c, order: i + 1 }))
        );
    };

    const updateContent = (index: number, field: keyof LearningContent, value: any) => {
        setContents(prev => prev.map((c, i) => i === index ? { ...c, [field]: value } : c));
    };

    const moveContent = (index: number, direction: 'up' | 'down') => {
        setContents(prev => {
            if ((direction === 'up' && index === 0) || (direction === 'down' && index === prev.length - 1)) {
                return prev;
            }
            const newContents = [...prev];
            const targetIndex = direction === 'up' ? index - 1 : index + 1;
            [newContents[index], newContents[targetIndex]] = [newContents[targetIndex], newContents[index]];
            return newContents.map((c, i) => ({ ...c, order: i + 1 }));
        });
    };

    return { contents, setContents, addContent, removeContent, updateContent, moveContent };
}
